/* @sravni/react-header version 0.2.43 */
var getUserName = function (user) {
    var nickname = user.nickname, _a = user.first_name, first_name = _a === void 0 ? '' : _a, phone_number = user.phone_number, email = user.email;
    var name = first_name.trim();
    if (name.length > 0)
        return name;
    if (nickname && nickname.trim().length > 0)
        return nickname;
    if (phone_number && phone_number.length > 0)
        return formatPhone(phone_number);
    if (email && email.length > 0)
        return email;
    return '';
};
var formatPhone = function (phone) {
    if (!phone) {
        return "";
    }
    var tmp = phone.replace(/\D/g, "");
    return "+" + tmp.slice(0, 1) + " " + tmp.slice(1, 4) + " " + tmp.slice(4, 7) + "-" + tmp.slice(7, 9) + "-" + tmp.slice(9);
};

export { formatPhone, getUserName };
//# sourceMappingURL=user.js.map
